import {environment} from '../../environments/environment';

/** Origine del backend (schema, host e porta), dall'ambiente di build. */
const ORIGINE_BACKEND = new URL(environment.host).origin;

/** Prefisso di tutte le API del backend (`API_PREFIX`). */
const PREFISSO_API = '/api';

/**
 * True se la richiesta è diretta alle API del backend: stessa origine di
 * `environment.host` e percorso sotto `/api`.
 *
 * Decide a chi può essere consegnato il token di accesso. Va confrontata
 * l'origine intera e non un prefisso di stringa: `https://tomcat1.desksite.it.evil.com`
 * inizia come il backend ma è un altro sito. Il percorso esclude anche le
 * altre risorse eventualmente servite dallo stesso host, che il token non
 * devono vederlo.
 *
 * Un indirizzo relativo si risolve rispetto alla pagina, cioè l'origine
 * del frontend: non è il backend, e infatti non riceve il token.
 */
export function isRichiestaBackend(url: string): boolean {
  try {
    const destinazione = new URL(url, window.location.origin);
    return destinazione.origin === ORIGINE_BACKEND
      && (destinazione.pathname === PREFISSO_API || destinazione.pathname.startsWith(`${PREFISSO_API}/`));
  } catch {
    // Indirizzo non interpretabile: nel dubbio il token non parte.
    return false;
  }
}
